module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[104]591.fd5f221.woff2";